<div class="details">
  <ng-container *ngIf="selectedValue$ | async as selectedValue">
    <div class="details__tab-nav">
      <app-custom-objects-details-tab-nav
        [tabs]="tabs"
        [tabId]="tabId"
        [editMode]="ui.editMode"
        [canEditLayout]="canEditLayout(selectedValue.customObject.name)"
        (panelAdded)="onPanelAdded($event)"
        (tabAdded)="onTabAdded($event)"
        (tabUpdated)="onTabUpdated($event)"
        (tabRemoved)="onTabRemoved($event)"
        (tabMoved)="onTabMoved($event)"
        (toggleEditMode)="onToggleEditMode()"
        (layoutSaved)="onLayoutSaved($event)"
        (tabChange)="onTabChange($event)"
      ></app-custom-objects-details-tab-nav>
    </div>
    <div class="details__content">
      <gridster [options]="gridOptions">
        <gridster-item [item]="item" *ngFor="let item of layoutItems[tabId]">
          <div class="details__content__panel">
            <div class="details__content__panel__actions" *ngIf="ui.editMode">
              <button
                mat-icon-button
                matTooltip="Delete me"
                class="delete-panel-handler"
                (mousedown)="$event.stopPropagation()"
                (click)="onRemovePanel(item)"
              >
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
              <button mat-icon-button matTooltip="Drag me" class="panel-handler drag-handler">
                <mat-icon svgIcon="drag_indicator"></mat-icon>
              </button>
            </div>
            <div id="panel-placeholder" *cdkDragPlaceholder></div>
            <div
              class="height-100p"
              [ngClass]="{ 'panel-boundry': ui.editMode }"
              [class.not-editable]="ui.panelIdInEditMode !== null && item.panel.id !== ui.panelIdInEditMode"
            >
              <app-panel-host
                #panels
                [panelDef]="item.panel"
                [fieldDefs]="relatedFieldDefs"
                [model]="selectedValue"
                [data]="routeData"
                [templateId]="selectedValue.template_id"
                [relatedToType]="selectedValue.customObject.name"
                [canEditLayout]="canEditLayout(selectedValue.customObject.name)"
                (panelDefUpdated)="onPanelDefUpdated($event)"
                (dataUpdated)="onDataUpdated($event)"
                (editToggled)="onEditToggled($event)"
              ></app-panel-host>
            </div>
          </div>
        </gridster-item>
      </gridster>
    </div>
  </ng-container>
</div>
